import React from "react";

const ListingReportList = React.lazy(() => import('src/pages/listing_report/ListingReportList'));
const ViewListingReport = React.lazy(() => import('src/pages/listing_report/ViewListingReport'));

const routes = [
    { path: '/dashboard/listing-report-list/:param', withParam: true, exact: true, name: "", element: ViewListingReport },
    { path: '/dashboard/listing-report-list', name: 'Listing Reports', element: ListingReportList },
];

export default routes;
